export const listIOS = [
    {
        content: "home.power_saving_mode.turn_on_wifi_screen",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/ios/en/image-1.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/ios/tr/image-1.webp"
    },
    {
        content: "home.power_saving_mode.enter_tk_wifi_network_details",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/ios/en/image-2.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/ios/tr/image-2.webp"
    },
    {
        content: "home.power_saving_mode.enable_low_data_mode",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/ios/en/image-3.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/ios/tr/image-3.webp"
    }
];

export const listAndroid = [
    {
        content: "home.power_saving_mode.open_connections_screen",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/android/en/image-1.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/android/tr/image-1.webp"
    },
    {
        content: "home.power_saving_mode.open_the_data_usage_screen",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/android/en/image-2.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/android/tr/image-2.webp"
    },
    {
        content: "home.power_saving_mode.open_the_data_saver_screen",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/android/en/image-3.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/android/tr/image-3.webp"
    },
    {
        content: "home.power_saving_mode.activate_data_saving",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/android/en/image-4.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/android/tr/image-4.webp"
    }
];

export const listMacOs = [
    {
        content: "home.power_saving_mode.enter_tk_wifi_network_details",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/macos/en/image-1.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/macos/tr/image-1.webp"
    },
    {
        content: "home.power_saving_mode.enable_low_data_mode",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/macos/en/image-2.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/macos/tr/image-2.webp"
    }
];

export const listWindows = [
    {
        content: "home.power_saving_mode.windows_settings_page",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/windows/en/image-1.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/windows/tr/image-1.webp"
    },
    {
        content: "home.power_saving_mode.windows_network_page",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/windows/en/image-2.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/windows/tr/image-2.webp"
    },
    {
        content: "home.power_saving_mode.windows_properties_page",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/windows/en/image-3.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/windows/tr/image-3.webp"
    },
    {
        content: "home.power_saving_mode.windows_metered_active",
        image: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/windows/en/image-4.webp",
        imageTr: process.env.PUBLIC_URL + "/images/power-saving-mode-introduction/windows/tr/image-4.webp"
    }
];
